import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addView: {
		id: 'tmp-feature-toggle.add-view',
		defaultMessage: 'Add view',
		description: "Menu item on the sidebar navigation to manage (add/remove) the project's feature",
	},
});
